import { SystemCode } from '../../models/systemCode';
import { QuoteRequest } from '../../models/services/api/postQuote';
import { ApplianceFormData } from '../../store/store.types';
export function formatQuoteRequest(
  formData: ApplianceFormData,
  systemCode?: SystemCode,
): QuoteRequest | undefined {
  const { VITE_BRAND_CODE } = import.meta.env;
  if (
    !formData.personalDetails ||
    !formData.applianceDetails ||
    !formData.modelSerial ||
    !formData.purchaseDate ||
    !formData.purchasePrice
  ) {
    return;
  }

  const {
    firstName,
    lastName,
    email,
    phoneDiallingCode,
    phoneNumber,
    addressLine1,
    addressLine2,
    city,
    regionOrStateCode,
    postalCode,
    merchandiseLocationLine1,
    merchandiseLocationLine2,
    merchandiseLocationCity,
    merchandiseLocationRegionOrStateCode,
    merchandiseLocationPostalCode,
  } = formData.personalDetails as Record<string, string>;

  const quoteRequest: QuoteRequest = {
    client: 'Whirlpool',
    customer: {
      firstName,
      lastName,
      email,
      addresses: [
        {
          addressLine1,
          addressLine2,
          city,
          regionOrStateCode,
          postalCode,
          countryCode: 'USA',
          isFormatted: formData.personalDetails.isFormatted as boolean,
          type: 'mailing',
        },
        {
          addressLine1: merchandiseLocationLine1,
          addressLine2: merchandiseLocationLine2,
          city: merchandiseLocationCity,
          regionOrStateCode: merchandiseLocationRegionOrStateCode,
          postalCode: merchandiseLocationPostalCode,
          countryCode: 'USA',
          isFormatted: formData.personalDetails.merchandiseLocationIsFormatted as boolean,
          type: 'applianceLocation',
        },
      ],
      phone: `${phoneDiallingCode}${phoneNumber?.replace(/\D/g, '')}`,
    },
    merchandise: [
      {
        brand: VITE_BRAND_CODE,
        modelNumber: formData.modelSerial.modelNumber as string,
        purchaseDate: formData.purchaseDate.purchaseDate as string,
        purchasePrice: formData.purchasePrice.purchasePrice as string,
        serialNumber: formData.modelSerial.serialNumber as string,
        type: formData.applianceDetails.itemCategory as string,
      },
    ],
    system: systemCode || 'DandG_IPR',
  };

  return quoteRequest;
}
